import { graphql } from '@/service/graphql'
import type { ResultOf } from 'gql.tada'
import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import { playParamsFrag } from '@/service/fragments/playParamsFrag'

// Video doesn't implement the PlayableEntity interface (the schema only
// lists Album/Artist/AudioPlayChapter/AudioPlayEpisode/Playlist/Podcast{Episode,Show}/Station/Track),
// so we can't `...playableEntity` here. Inline the fields the
// recommendation pipeline needs (__typename + playParams).
// language=GraphQL
export const videoFieldsFrag = graphql(
    `
        fragment videoFields on Video @_unmask {
            __typename
            id
            name
            duration
            videoType
            playbackId
            uri
            url
            playParams {
                ...playParams
            }
            contributingArtists {
                concatenatedName
            }
            images {
                ...imageFields
            }
        }
    `,
    [imageFieldsFrag, playParamsFrag]
)

export type VideoFields = ResultOf<typeof videoFieldsFrag>
